export default "assets/images/cd213169df16398b0017450e31788d73.png";